import { render, staticRenderFns } from "./createPrve.vue?vue&type=template&id=79c07eb1&scoped=true"
import script from "./createPrve.vue?vue&type=script&lang=js"
export * from "./createPrve.vue?vue&type=script&lang=js"
import style0 from "./createPrve.vue?vue&type=style&index=0&id=79c07eb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c07eb1",
  null
  
)

export default component.exports